import React from "react";
import {defineMessages, injectIntl} from "react-intl";
import MsPanelButton from "./ms-panel-button.jsx";

const maxSeconds = 10;

const messages = {
  internet_error: {
    header: "Offline",
    message: "You are currently offline. Please check you internet connection and refresh this page.",
    counter: false
  },
  stream_error: {
    header: "Stream Error Occured",
    message: "Stream Error Occured, Refresh you page",
    message2: "Stream Error Occured",
    counter: false
  },
  stream_completed: {
    header: "Stream Inactive",
    message: "The presenter is currently not streaming.",
    counter: false
  },
  stream_stopped: {
    header: "Stream Stopped",
    message: "The presenter has momentarily stopped the stream.",
    counter: false
  },
  connection_slow: {
    header: "Poor Connection",
    message: "The stream keep loading due connection issues. Please check your internet connection.",
    counter: false
  },
  resolution_high: {
    header: "Poor Connection",
    message: "The actual resolution is too high for your connection. Please check your internet connection or switch to a lower resolution.",
    counter: false
  },
  player_not_loading: {
    header: "Stream not loading",
    message: "The stream is taking too long to load. Reload player.",
    counter: false
  },
  max_attempt_reached: {
    header: "Stream not loading",
    message: "Stream Error. Please reload the page ",
    counter: false
  },
};

const hasCloseButton = [
  'connection_slow', 'resolution_high'
]

class MSStreamError extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      seconds: maxSeconds
    };
    this.currError = {};
    this.timer = 0;
    this.startTimer = this.startTimer.bind(this);
    this.countDown = this.countDown.bind(this);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  startTimer() {
    clearInterval(this.countDown);
    if (this.timer == 0 && this.state.seconds > 0) {
      this.setState({
        seconds: maxSeconds,
      });
      this.timer = setInterval(this.countDown, 1000);
    }
  }

  countDown() {
    // Remove one second, set state so a re-render happens.
    let curSeconds = this.state.seconds - 1;
    this.setState({
      seconds: curSeconds,
    });

    // Check if we're at zero.
    if (curSeconds == 0) {
      clearInterval(this.timer);
      if (this.props.callback) {
        this.props.callback();
      }
    }
  }

  render() {
    let closeButton = null;
    this.currError = messages[this.props.errorType];
    if (this.timer == 0 && this.currError.counter) {
      this.startTimer();
    }
    if (hasCloseButton.includes(this.props.errorType)) {
      closeButton = (
        <div className="emb-stream-status__actions">
          <MsPanelButton
            id="modal_close_btn"
            label="Ok"
            onClickEvent={this.props.callback}
            classes="btn-primary alt"
          />
        </div>
      );
    }
    return (
      <div className="wpstream_payment_backgorund">
        <div className="embv_checkout_page emb-stream-status-page">
          <div className="stream_title">
            <h1>{this.currError.header}</h1>
          </div>
          <div id="modal-container">
            <div className="emb-stream-status">
              <p className="emb-stream-status__message">
                {this.currError.message}
                {this.currError.counter ? (
                  <span id="reconnect_counter"> {this.state.seconds}</span>
                ) : null}
              </p>
              {closeButton}
            </div>
          </div>
        </div>
      </div>
    );
  }

}
export default injectIntl(MSStreamError);
